import {  UPDATE_DELIVERY_DATE_IN_LIVEOPS_URL } from "../../config/Url";
import axios from "../../interceptors/axiosInterceptor";
import { getAuthOptions } from "../../config/Headers";
import { normalizeCatchErrors } from "../../utils/errorUtils";


export const updateDeliveryDateInLiveopsApi = (payload: FormData) =>
  new Promise<void>((resolve, reject) => {
    axios
      .post(UPDATE_DELIVERY_DATE_IN_LIVEOPS_URL, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          const data = response && response.data;
          resolve(data);
        } 
        //else {
        //   reject({ errors: "Something went wrong" });
        // }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
